import React, {useRef, useState, useEffect} from 'react';

import {
  Grid,
  TextField,
  FormHelperText,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import SelectForm from '../Select';
import DatePicker from '../DatePicker';
import FileIcon from '../../Utils/icons/file.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import MultipleSelectCheckmarks from '../multipleSelect';
export default function Form({
  field,
  handleChangeMain,
  error,
  dependencyFilter,
  valueField,
  setNameFile,
  nameFile,
  setBase64File,
  serialNumber,
}) {
  const fileInputRefs = useRef({}); // Almacena referencias a cada input de archivo
  const [fileInputs, setFileInputs] = useState({}); // Estado para los archivos seleccionados
  useEffect(() => {
    setBase64File(fileInputs);
  }, [fileInputs]);
  if (Object.keys(field)?.length === 0) return true;
  let data = [...field?.principales, ...field?.atributos];

  const handleChange = (value, fields) => {
    handleChangeMain(value, fields);
  };

  const handleUploadFile = inputId => {
    if (fileInputRefs.current[inputId]) {
      fileInputRefs.current[inputId].click();
    }
  };

  const handleFileChange = async (event, inputId, itemName, itemCodigo) => {
    if (!event.target.files.length) return;

    const filesArray = Array.from(event.target.files);
    const existingFiles = fileInputs[inputId]?.filesInfo || [];
    const existingNames = new Set(existingFiles.map(file => file.nombre));

    // Filtrar archivos ya existentes para evitar duplicados
    const newFiles = filesArray.filter(file => !existingNames.has(file.name));

    if (newFiles.length === 0) return;

    // Convertir archivos a Base64 usando Promises
    const base64Promises = newFiles.map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>
          resolve({nombre: file.name, base64: reader.result.split(',')[1]});
        reader.onerror = reject;
      });
    });

    try {
      const results = await Promise.all(base64Promises);

      setFileInputs(prev => ({
        ...prev,
        [inputId]: {
          filesInfo: [
            ...existingFiles,
            ...results.map(r => ({descripcion: r.nombre})),
          ],
          base64Files: [
            ...(prev[inputId]?.base64Files || []),
            ...results.map(r => ({
              nombre: itemName,
              codigo: itemCodigo,
              id: itemCodigo,
              descripcion: r.nombre,
              base64: r.base64,
            })),
          ],
        },
      }));
      if (results.length > 0) {
        handleChange(results[0].base64, itemCodigo);
      }
    } catch (error) {
      console.error('Error procesando archivos:', error);
    }
  };

  // Función para eliminar un archivo específico de un input
  const handleRemoveFile = (inputId, fileIndex) => {
    setFileInputs(prevState => {
      const updatedFilesInfo = [...prevState[inputId].filesInfo];
      const updatedBase64Files = [...prevState[inputId].base64Files];

      updatedFilesInfo.splice(fileIndex, 1);
      updatedBase64Files.splice(fileIndex, 1);

      return {
        ...prevState,
        [inputId]: {
          filesInfo: updatedFilesInfo,
          base64Files: updatedBase64Files,
        },
      };
    });
  };
  const fieldForHidden = ['id_tercero_cliente', 'id_sucursal', 'id_equipo'];
  return (
    <Grid
      className={'marginTop styleInputs inputMain'}
      container
      rowSpacing={1}
      columnSpacing={{xs: 1, sm: 2, md: 3}}>
      {data?.map((itemData, key) => {
        let classShowFields = 'none';
        if (valueField[data[0].id]) classShowFields = 'block';
        if (key === 0) classShowFields = 'block';
        if (
          (fieldForHidden.includes(itemData.id) && serialNumber) ||
          itemData?.parametro?.opcion === 'ocultar'
        ) {
          classShowFields = 'none';
          return;
        }
        if (
          itemData.tipo === 'tabla' ||
          itemData.tipo === 'lista' ||
          itemData.tipo === 'listaSinComentarios'
        ) {
          return (
            <Grid
              item
              md={6}
              sm={6}
              xs={12}
              key={key}
              style={{display: classShowFields}}>
              <div style={{display: [classShowFields]}}>
                <SelectForm
                  data={itemData}
                  handleChange={handleChange}
                  dependencyFilter={dependencyFilter}
                  valueField={valueField}
                  serialNumber={serialNumber}
                />
                <FormHelperText className={'errorMenssage'}>
                  {error[itemData.id]}
                </FormHelperText>
              </div>
            </Grid>
          );
        } else if (
          itemData.tipo === 'texto' ||
          itemData.tipo === 'textoLargo' ||
          itemData.tipo === 'numero'
        ) {
          let valueText = valueField[itemData.id];
          if (!valueText) valueText = '';
          if (
            itemData?.parametro?.opcion === 'ocultar' &&
            itemData?.parametro?.valor
          ) {
            classShowFields = 'none';
            return;
          }
          let numberRow = itemData.tipo === 'textoLargo' ? 3 : 1;
          if (itemData.id === 'motivoServicio') {
            return (
              <Grid item md={6} sm={6} xs={12} key={key}>
                <div style={{display: classShowFields}}>
                  <TextField
                    required={itemData?.obligatorio}
                    label={itemData.item}
                    variant="outlined"
                    multiline
                    fullWidth={true}
                    value={
                      valueField[itemData.id]
                        ? valueField[itemData.id]
                        : itemData?.parametro?.opcion === 'ver' &&
                            itemData?.parametro?.valor
                          ? itemData?.parametro?.valor
                          : ''
                    }
                    disabled={
                      itemData?.parametro?.opcion === 'ver' &&
                      itemData?.parametro?.valor
                        ? true
                        : false
                    }
                    inputProps={{maxLength: itemData.longitud}}
                    onChange={e => handleChange(e.target.value, itemData.id)}
                  />
                  <FormHelperText className={'errorMenssage'}>
                    {error[itemData.id]}
                  </FormHelperText>
                </div>
              </Grid>
            );
          }
          return (
            <Grid item md={6} sm={6} xs={12} key={key}>
              <div style={{display: classShowFields}}>
                <TextField
                  required={itemData?.obligatorio}
                  label={itemData.item}
                  variant="outlined"
                  multiline
                  rows={numberRow}
                  fullWidth={true}
                  value={
                    valueField[itemData.id]
                      ? valueField[itemData.id]
                      : itemData?.parametro?.opcion === 'ver' &&
                          itemData?.parametro?.valor
                        ? itemData?.parametro?.valor
                        : ''
                  }
                  disabled={
                    itemData?.parametro?.opcion === 'ver' &&
                    itemData?.parametro?.valor
                      ? true
                      : false
                  }
                  inputProps={{maxLength: itemData.longitud}}
                  onChange={e => handleChange(e.target.value, itemData.id)}
                />
                <FormHelperText className={'errorMenssage'}>
                  {error[itemData.id]}
                </FormHelperText>
              </div>
            </Grid>
          );
        } else if (itemData.tipo === 'multipleSeleccion') {
          return (
            <Grid item md={6} sm={6} xs={12} key={key}>
              <div style={{display: classShowFields}}>
                <MultipleSelectCheckmarks
                  data={itemData}
                  handleChange={handleChange}
                />
              </div>
              <FormHelperText className={'errorMenssage'}>
                {error[itemData.id]}
              </FormHelperText>
            </Grid>
          );
        } else if (itemData.tipo === 'fecha') {
          return (
            <Grid item md={6} sm={6} xs={12} key={key}>
              <div style={{display: classShowFields, zIndex: 100000}}>
                <DatePicker
                  handleChange={handleChange}
                  data={itemData}
                  valueField={valueField}
                />
                <FormHelperText className={'errorMenssage'}>
                  {error[itemData.id]}
                </FormHelperText>
              </div>
            </Grid>
          );
        } else if (
          itemData.tipo === 'archivo' &&
          (!itemData.parametro || itemData.parametro.opcion !== 'ocultar')
        ) {
          const inputId = itemData.id;
          return (
            <Box
              key={inputId}
              style={{display: classShowFields, marginTop: 20}}
              width={1}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                <Box
                  style={{
                    border: 'solid',
                    borderColor: '#c7c7c7',
                    padding: 8,
                    boxShadow: '0px 0px 3px 0px rgba(199, 199, 199, 0.75)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                  width={1 / 2}>
                  <input
                    type="file"
                    ref={el => (fileInputRefs.current[inputId] = el)}
                    onChange={e =>
                      handleFileChange(e, inputId, itemData.item, itemData.id)
                    }
                    multiple
                    style={{display: 'none'}}
                    accept=".pdf,.jpg,.png"
                  />
                  <Box
                    onClick={() =>
                      (!itemData.parametro ||
                        itemData.parametro.opcion !== 'ver') &&
                      handleUploadFile(inputId)
                    }
                    style={{
                      background:
                        !itemData.parametro ||
                        (itemData.parametro.opcion !== 'ver' &&
                          !itemData?.parametro?.valor)
                          ? '#28679d'
                          : '#a5a5a5',
                      padding: 8,
                      marginBottom: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor:
                        (!itemData.parametro ||
                          (itemData.parametro.opcion !== 'ver' &&
                            !itemData?.parametro?.valor)) &&
                        'pointer',
                      borderRadius: 5,
                    }}>
                    <Typography style={{color: '#fff', marginRight: 8}}>
                      {itemData.item}
                    </Typography>
                    <img
                      style={{width: '1.5em'}}
                      src={FileIcon}
                      alt="File Icon"
                    />
                  </Box>
                  <Box>
                    {fileInputs[inputId]?.filesInfo?.map((file, fileIndex) => (
                      <Box
                        key={fileIndex}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={1}
                        p={1}
                        style={{
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          width: '100%',
                        }}>
                        <Typography
                          variant="body2"
                          noWrap
                          style={{flexGrow: 1}}>
                          {file.descripcion}
                        </Typography>
                        <IconButton
                          onClick={() => handleRemoveFile(inputId, fileIndex)}
                          color="error">
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                </Box>
                <FormHelperText className={'errorMenssage'}>
                  {error[itemData.id]}
                </FormHelperText>
              </div>
            </Box>
          );
        }
      })}
    </Grid>
  );
}
